import { Component, OnInit,Input,EventEmitter,Output,ViewChild} from '@angular/core';
import{QuestionManagementService} from '../../../Services/question-management/question-management.service';
import { Subject } from 'rxjs';
import { Router,ActivatedRoute } from '@angular/router';
import { MATHtest } from '../../../../assets/js/fullscreen';
import { QuestionAddEditComponent } from '../question-add-edit/question-add-edit.component';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';
@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.css'],
})
export class QuestionListComponent implements OnInit {
  constructor(
    public service: QuestionManagementService,
    public flashservice: FlashCardManagementService,
    public Activeroute: ActivatedRoute,
    public route: Router
  ) {}
  // @ViewChild('childComponent') child:QuestionAddEditComponent;
  @Input() Questionlistresponse: any;
  @Input() selectQuestionTemplate: any;
  @Input() ScreenName1: string;
  @Input() questionsubjectresponse: any;
  @Input() subjectID: any;
  @Input() subjectById: any;
  @Input() selectedQuestionList: any;
  @Output() QuestionTemplate: EventEmitter<any> = new EventEmitter<any>();
  @Output() RefreshEditQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseEditQuestion1: EventEmitter<any> = new EventEmitter<any>();

  //@Output() EditAnswerChoiceNoteBody: EventEmitter<any> = new EventEmitter<any>();

  redirect: boolean = false;
  //@Input('EditQuestion') EditQuestion1:Subject<any>;

  //@Input() selectedQuestionById:any;

  ngOnInit() {
    // if(this.subjectID>0){
    //   this.getsubjectId(this.subjectID)
    this.getQuestionTemplateList();
  }

  //selectedQuestionList:any;
  Question: any;
  getQuestionTemplateList() {
    this.service
      .GetQuestionTemplate({ LoggedInUserID: 'Vel_S_Pil_1' })
      .subscribe(
        (i: any) => {
          this.Question = i;
          this.selectedQuestionList = this.Question.result;
          this.selectedQuestionList.map((obj: { checkedflag: boolean }) => {
            obj.checkedflag = false;
            return obj;
          });
        },
        (error) => {
          console.log(error);
        }
      );
    // }).catch((e:any)=>{
    //   this.selectedQuestionList=null;
    // });
  }

  selectedQuestionById: any;
  Questionlist: any;
  Questionid: string;

  getQuestionByID(data: any) {
    this.service.GetQuestionByID({ QuestionID: data }).subscribe(
      (i: any) => {
        this.Questionlist = i;
        this.selectedQuestionById = this.Questionlist.result;
        this.service.QuestionByIDlist = this.selectedQuestionById;

        if (Array.isArray(this.selectedQuestionList)) {
          for (let item of this.selectedQuestionList) {
            if (
              item.Question_Template_ID ==
              this.selectedQuestionById[0].Question_Template_ID
            ) {
              item.checkedflag = true;
            } else {
              item.checkedflag = false;
            }
          }
        }

        if (
          Array.isArray(this.selectedQuestionList) &&
          this.selectedQuestionList[0] != null &&
          this.selectedQuestionById[0] != null &&
          this.subjectById != null
        ) {
          if (!this.EditQuestionFlag) {
            this.Editpopup();
          }
        }

        // }).catch((e:any)=>{
        //   this.selectedQuestionById=null;

        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  Modalclose: boolean;
  CloseQuestionTemplate() {
    this.QuestionTemplate.emit(this.Modalclose);
  }

  question: any;
  EditQuestion(data: any) {
    this.question = data;
    if (data) {
      if (data.Question_Id) {
        this.getQuestionByID(data.Question_Id);
      } else if (data.Question_ID) {
        this.getQuestionByID(data.Question_ID);
      }
    } else {
      if (!this.EditQuestionFlag) {
        this.Editpopup();
      }
    }
  }
  EditQuestionFlag: boolean;
  Editpopup() {
    if (this.EditQuestionFlag) {
      this.flashservice.refreshQuestionList(false);
    }
    this.EditQuestionFlag = !this.EditQuestionFlag;
  }

  getsubjectId(data: any) {
    let ID: Number = 0;
    try {
      if (data > 0 || data == null) {
        ID = Number(data);
      } else if (Number(data.ID) > 0) {
        ID = Number(data.ID);
      }
    } catch {}
    this.service.getsubjectById({ CurrentNodeSubjectID: Number(ID) }).subscribe(
      (i: any) => {
        this.subjectById = i;
        // if(this.AddQuestionflag){
        //   this.QuestionTemplateType();
        // }

        // }).catch((e:any)=>{
        //   this.subjectById=null;
        // }
        // )
      },
      (error) => {
        console.log(error);
      }
    );
  }

  //#region Navigation methods
  ClickQuestionBody(data: any) {
    this.selectedQuestionById = data;
    this.QuestionBody();
  }

  returnfromanswer(data: any) {
    this.EditAnswerChoicePopup = !this.EditAnswerChoicePopup;
    this.selectedQuestionById = data;
    this.QuestionBody();
  }

  Answerflag: any;
  ClickAnswerChoice(data: any) {
    this.Answerflag = 'R';
    this.selectedQuestionById = data.QuestionById;
    this.Answerflag = data.Answerflag1;
    this.AnswerChoiceBody();
  }

  EditAnswerNote(data: any) {
    this.selectedQuestionById = data;
    this.EditAnswerChoiceBody();
  }

  EditAnswerChoiceNoteBody(data: any) {
    this.selectedQuestionById = data;
    this.AnswerChoiceNoteBody();
  }

  // EditSolutionHint(data:any){
  //   this.selectedQuestionById=data;
  //  this.SolutionHintBody(1);
  // }
  //#endregion

  //#region Open Modal popup
  EditAnswerChoicePopup: boolean;
  AnswerChoiceBody() {
    this.redirect = false;
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.EditAnswerChoicePopup = !this.EditAnswerChoicePopup;
  }

  EditAnswerChoiceNotePopup1: boolean;
  EditAnswerChoiceBody() {
    this.redirect = false;
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.EditAnswerChoiceNotePopup1 = !this.EditAnswerChoiceNotePopup1;
  }

  AnswerChoiceNotePopup1: boolean;
  AnswerChoiceNoteBody() {
    this.redirect = false;
    if (this.EditAnswerChoicePopup) {
      this.AnswerChoiceBody();
    }
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.AnswerChoiceNotePopup1 = !this.AnswerChoiceNotePopup1;
  }
  //Solution Hint
  SolutionHintPopup: boolean;
  SolutionHintBody() {
    this.redirect = false;
    if (this.EditAnswerChoicePopup) {
      this.AnswerChoiceBody();
    }
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.SolutionHintPopup = !this.SolutionHintPopup;
  }

  EditSolutionHintBodyPopup: boolean;
  EditSolutionHintBody() {
    this.redirect = false;
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.EditSolutionHintBodyPopup = !this.EditSolutionHintBodyPopup;
  }
  //solutin hint

  EditQuestionBodyPopup: boolean;
  QuestionBody() {
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
  }

  AnswerChoiceQuestionBody() {
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
  }
  //#endregion
  //#region
  CloseEditQuestion(data: any) {
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    if (
      this.subjectById.Selected_Header_ID != null &&
      this.subjectById.Selected_Header_ID != 'undefined'
    ) {
      this.RefreshEditQuestion.emit(this.subjectById.Selected_Header_ID);
    }
    // else{
    //   this.RefreshEditQuestion.emit(this.subjectById.Subject_Id);
    // }
    //this.RefreshEditQuestion.emit(this.subjectById.Selected_Header_ID);
    //this.getActivityhistory.emit(this.subjectById.Subject_Id);
    //this.CloseEditQuestion1.emit(this.subjectById.Subject_Id)
  }
  //#endregion

  //#region Refresh page

  ReturnEdit() {
    //if(this.ReturnScreenName!='Preview'){
    this.redirect = false;
    // this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
    this.getQuestionByID(this.service.QuestionByIDlist[0].Question_ID);
    if (this.EditQuestionBodyPopup) {
      this.QuestionBody();
    }
    // }
    //   else{
    //redirect to preview
    // if(this.EditQuestionBodyPopup){
    //   this.EditQuestionBodyPopup=!this.EditQuestionBodyPopup
    // }

    // this.Questionpreviewpopupflag=!this.Questionpreviewpopupflag;
    // this.ReturnScreenName='';
    // this.redirectscreenname=null;
    //}
  }

  Returnpreview(data: any) {
    //redirect to preview
    if (this.EditQuestionBodyPopup) {
      this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
    }

    this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
    this.ReturnScreenName = '';
    this.redirectscreenname = null;
  }

  ReturnAnswerEdit() {
    //if(this.ReturnScreenName!='Preview'){
    this.redirect = false;
    this.getQuestionByID(this.selectedQuestionById.Question_ID);
    if (this.EditAnswerChoicePopup) {
      this.AnswerChoiceBody();
    }
    // }
    // else{
    //redirect to preview
    //   if(this.EditAnswerChoicePopup){
    //     this.EditAnswerChoicePopup=!this.EditAnswerChoicePopup
    //   }

    //   this.Questionpreviewpopupflag=!this.Questionpreviewpopupflag;
    //   this.ReturnScreenName='';
    //   this.redirectscreenname=null;
    // }
  }

  ReturnAnswerNote() {
    this.redirect = false;
    this.getQuestionByID(this.selectedQuestionById.Question_ID);
    if (this.AnswerChoiceNotePopup1) {
      this.AnswerChoiceNoteBody();
    }
  }
  //solution hint
  ReturnSolutionHint() {
    this.redirect = false;
    this.getQuestionByID(this.selectedQuestionById.Question_ID);
    if (this.SolutionHintPopup) {
      this.SolutionHintBody();
    }
  }
  ReturnEditSolutionHint() {
    if (this.ReturnScreenName != 'Preview') {
      this.redirect = false;
      this.getQuestionByID(this.selectedQuestionById.Question_ID);
      if (this.EditSolutionHintBodyPopup) {
        this.EditSolutionHintBody();
      }
    } else {
      //redirect to preview
      if (this.EditSolutionHintBodyPopup) {
        this.EditSolutionHintBodyPopup = !this.EditSolutionHintBodyPopup;
      }

      this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
      this.ReturnScreenName = '';
      this.redirectscreenname = null;
    }
  }
  //solution hint
  ReturnAnswerNote1() {
    if (this.ReturnScreenName != 'Preview') {
      this.redirect = false;
      this.getQuestionByID(this.selectedQuestionById.Question_ID);
      if (this.EditAnswerChoiceNotePopup1) {
        this.EditAnswerChoiceBody();
      }
    } else {
      //redirect to preview
      if (this.EditAnswerChoiceNotePopup1) {
        this.EditAnswerChoiceNotePopup1 = !this.EditAnswerChoiceNotePopup1;
      }

      this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
      this.ReturnScreenName = '';
      this.redirectscreenname = null;
    }
  }

  ReturnQuestionpreview(data: any) {
    if (!this.redirectscreenname) {
      this.getQuestionByID(this.service.QuestionByIDlist[0].Question_ID);
      if (this.Questionpreviewpopupflag) {
        this.QuestionPreview();
      }
    } else {
      this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
    }
  }
  ReturnQuestionreview() {
    this.redirect = false;
    this.getQuestionByID(this.selectedQuestionById.Question_ID);
    if (this.Questionreviewpopupflag) {
      this.Questionreview();
    }
  }
  ReturnQuestionStatus() {
    this.redirect = false;
    this.getQuestionByID(this.selectedQuestionById.Question_ID);
    if (this.QuestionStatuspopupflag) {
      this.QuestionStatusPopup();
    }
  }
  //#endregion

  //#region Close Modal popup

  EditQuestionBodyclose(data: any) {
    this.redirect = false;
    this.ReturnEdit();
    //this.redirect='W';
  }

  //redirect from question body and answer answer screen to preview
  RightAnswer1: any;
  EmitAnswerChoiceDetails(data: any) {
    this.RightAnswer1 = data;
  }

  currentlist: any;
  EmitpreviewDetails(data: any) {
    this.previewdetail = data;
    this.currentlist = data;
  }
  Screenname: any;
  REdirecttoRightAnswer(data: any) {
    this.Screenname = data;
    this.ReturnAnswer();
  }
  redirectscreenname: string | null;
  REdirectPreview(data: any) {
    this.redirectscreenname = data.Screename;
    this.previewdetail.safehtmlStr = data.safehtmlStr;
    this.QuestionPreview();

    // if(this.EditQuestionBodyPopup){
    //   //this.AnswerChoiceQuestionBody();
    //   this.QuestionBody();
    // }
  }
  Questionrefreshpreview(data: any) {
    this.redirectscreenname = data.Screename;
    this.previewdetail.safehtmlStr = data.safehtmlStr;
  }

  AnswerRedirectPreview(data: any) {
    this.redirectscreenname = data.Screename;
    if (data.Indicator == 0) {
      this.previewdetail.RightAnswer11 = data.safehtmlStr;
    } else if (data.Indicator == 1) {
      this.previewdetail.WrongAnswer11 = data.safehtmlStr;
    } else if (data.Indicator == 2) {
      this.previewdetail.WrongAnswer22 = data.safehtmlStr;
    } else if (data.Indicator == 3) {
      this.previewdetail.WrongAnswer33 = data.safehtmlStr;
    } else if (data.Indicator == 4) {
      this.previewdetail.WrongAnswer44 = data.safehtmlStr;
    } else if (data.Indicator == 5) {
      this.previewdetail.WrongAnswer55 = data.safehtmlStr;
    } else if (data.Indicator == 6) {
      this.previewdetail.WrongAnswer66 = data.safehtmlStr;
    } else if (data.Indicator == 7) {
      this.previewdetail.WrongAnswer77 = data.safehtmlStr;
    }
    // this.previewdetail.safehtmlStr=data.safehtmlStr;
    this.QuestionPreview();
  }

  RefreshPreviewAnswer(data: any) {
    if (data.Indicator == 0) {
      this.previewdetail.RightAnswer11 = data.safehtmlStr;
    } else if (data.Indicator == 1) {
      this.previewdetail.WrongAnswer11 = data.safehtmlStr;
    } else if (data.Indicator == 2) {
      this.previewdetail.WrongAnswer22 = data.safehtmlStr;
    } else if (data.Indicator == 3) {
      this.previewdetail.WrongAnswer33 = data.safehtmlStr;
    } else if (data.Indicator == 4) {
      this.previewdetail.WrongAnswer44 = data.safehtmlStr;
    } else if (data.Indicator == 5) {
      this.previewdetail.WrongAnswer55 = data.safehtmlStr;
    } else if (data.Indicator == 6) {
      this.previewdetail.WrongAnswer66 = data.safehtmlStr;
    } else if (data.Indicator == 7) {
      this.previewdetail.WrongAnswer77 = data.safehtmlStr;
    }
  }

  SelectedAnswer: any;
  AnswerIndicator: string;
  AnswerChoice: any;
  AnswerChoiceByQuestionid: any;
  ReturnAnswer() {
    //this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
    let Templist = {
      Answer_Choice_ID: null,
      Question_ID: this.selectedQuestionById[0].Question_ID,
      Question_Status_ID: this.selectedQuestionById[0].Question_Status_ID,
    };

    this.service
      .GetAnswerChoiceByQuestionID({
        QuestionID: this.service.QuestionByIDlist[0].Question_ID,
      })
      .subscribe(
        (i: any) => {
          this.AnswerChoice = i;
          this.AnswerChoiceByQuestionid = this.AnswerChoice.SubjectExistsInd;
          if (this.AnswerChoiceByQuestionid.length != 0) {
            if (this.AnswerChoiceByQuestionid[0].Answer_Choice_ID != null) {
              this.SelectedAnswer = this.AnswerChoiceByQuestionid[0];
              if (this.AnswerChoiceByQuestionid[0].Right_Answer_Ind == 'Y') {
                this.AnswerIndicator = 'R';
              } else {
                this.AnswerIndicator = 'W';
              }
            } else {
              this.SelectedAnswer = Templist;
            }
          } else {
            this.SelectedAnswer = Templist;
          }
          // if(this.RightAnswer1!=null){
          // this.SelectedAnswer=this.RightAnswer1;
          // this.AnswerIndicator='R';
          // }
          // else{
          // this.SelectedAnswer=Templist;
          // }
          let list = {
            QuestionById: this.SelectedAnswer,
            Answerflag1: this.AnswerIndicator,
          };

          this.ClickAnswerChoice(list);

          if (this.EditQuestionBodyPopup) {
            this.QuestionBody();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  //////

  EditAnswerchoiceclose(data: any) {
    this.redirect = false;

    this.ReturnAnswerEdit();
  }

  EditAnswerchoiceNoteclose(data: any) {
    this.redirect = false;

    this.ReturnAnswerNote();
  }

  EditAnswerchoiceNoteclose1(data: any) {
    this.redirect = false;

    this.ReturnAnswerNote1();
  }

  EditAnswerchoiceNoteclose11(data: any) {
    this.redirect = false;
    this.ReturnSolutionHint();
  }

  EditAnswerchoiceNoteclose12(data: any) {
    this.redirect = false;
    this.ReturnEditSolutionHint();
  }
  Questionreviewclose(data: any) {
    this.redirect = false;
    if (this.Questionreviewpopupflag) {
      this.flashservice.refreshQuestionList(false);
      this.Questionreview();
    }
  }
  ReturnQuestionreviewclose(data: any) {
    this.redirect = false;
    this.ReturnQuestionreview();
  }
  ReturnQuestionStatushistory(data: any) {
    this.redirect = false;
    this.ReturnQuestionStatus();
  }
  //#endregion
  previewdetail: any;
  ClickQuestionPreview(data: any) {
    this.previewdetail = data;
    this.QuestionPreview();
  }
  Questionpreviewpopupflag: boolean;
  QuestionPreview() {
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
  }

  Questionstatus: any;
  ClickQuestionstatus(data: any) {
    this.selectedQuestionById = data.Question;
    this.Questionstatus = data.Question_status;
    this.Questionreview();
  }

  Questionreviewpopupflag: boolean;
  Questionreview() {
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.Questionreviewpopupflag = !this.Questionreviewpopupflag;
  }

  QuestionStatuspopupflag: boolean;
  QuestionStatusPopup() {
    if (this.EditQuestionFlag) {
      this.Editpopup();
    }
    this.QuestionStatuspopupflag = !this.QuestionStatuspopupflag;
  }

  ClickQuestionStatusPopup(data: any) {
    this.selectedQuestionById = data;
    this.QuestionStatusPopup();
  }

  EditSolutionHint(data: any) {
    this.selectedQuestionById = data;
    this.EditSolutionHintBody();
  }
  EditSolutionHint1(data: any) {
    this.selectedQuestionById = data;
    this.SolutionHintBody();
  }

  Refreshlist(data: any) {
    this.getQuestionByID(data);
  }

  //redirect from preview
  ReturnScreenName: string;
  EmitpreviewtoQuestion(data: any) {
    this.ReturnScreenName = 'Preview';
    if (this.EditQuestionBodyPopup) {
      this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
    }
    this.ClickQuestionBody(this.service.QuestionByIDlist);
    this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
    // if(this.EditQuestionBodyPopup){
    //   this.EditQuestionBodyPopup=!this.EditQuestionBodyPopup;
    // }
    if (this.EditAnswerChoicePopup) {
      this.EditAnswerChoicePopup = !this.EditAnswerChoicePopup;
    }
    if (this.EditAnswerChoiceNotePopup1) {
      this.EditAnswerChoiceNotePopup1 = !this.EditAnswerChoiceNotePopup1;
    }
    if (this.EditSolutionHintBodyPopup) {
      this.EditSolutionHintBodyPopup = !this.EditSolutionHintBodyPopup;
    }
  }
  EmitpreviewtoAnswerChoice(data: any) {
    this.ReturnScreenName = 'Preview';
    if (this.EditAnswerChoicePopup) {
      this.EditAnswerChoicePopup = !this.EditAnswerChoicePopup;
    }
    this.RightAnswer1 = this.service.AnswerChoicelist;
    this.PreviewAnswer();
    if (this.EditQuestionBodyPopup) {
      this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
    }
    // if(this.EditAnswerChoicePopup){
    //   this.EditAnswerChoicePopup=!this.EditAnswerChoicePopup;
    // }
    if (this.EditAnswerChoiceNotePopup1) {
      this.EditAnswerChoiceNotePopup1 = !this.EditAnswerChoiceNotePopup1;
    }
    if (this.EditSolutionHintBodyPopup) {
      this.EditSolutionHintBodyPopup = !this.EditSolutionHintBodyPopup;
    }
  }

  EmitpreviewtoAnswerChoiceNote(data: any) {
    this.ReturnScreenName = 'Preview';
    if (this.EditAnswerChoiceNotePopup1) {
      this.EditAnswerChoiceNotePopup1 = !this.EditAnswerChoiceNotePopup1;
    }
    this.RightAnswer1 = this.service.AnswerChoicelist;
    this.EditAnswerNote(this.RightAnswer1);
    this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
    if (this.EditQuestionBodyPopup) {
      this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
    }
    if (this.EditAnswerChoicePopup) {
      this.EditAnswerChoicePopup = !this.EditAnswerChoicePopup;
    }
    // if(this.EditAnswerChoiceNotePopup1){
    //   this.EditAnswerChoiceNotePopup1=!this.EditAnswerChoiceNotePopup1;
    // }
    if (this.EditSolutionHintBodyPopup) {
      this.EditSolutionHintBodyPopup = !this.EditSolutionHintBodyPopup;
    }
  }
  EmitpreviewtoSolutionHint(data: any) {
    this.ReturnScreenName = 'Preview';
    if (this.EditSolutionHintBodyPopup) {
      this.EditSolutionHintBodyPopup = !this.EditSolutionHintBodyPopup;
    }
    this.RightAnswer1 = this.service.AnswerChoicelist;
    this.EditSolutionHint(this.RightAnswer1);
    this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
    if (this.EditQuestionBodyPopup) {
      this.EditQuestionBodyPopup = !this.EditQuestionBodyPopup;
    }
    if (this.EditAnswerChoicePopup) {
      this.EditAnswerChoicePopup = !this.EditAnswerChoicePopup;
    }
    if (this.EditAnswerChoiceNotePopup1) {
      this.EditAnswerChoiceNotePopup1 = !this.EditAnswerChoiceNotePopup1;
    }
    //  if(this.EditSolutionHintBodyPopup){
    //     this.EditSolutionHintBodyPopup=!this.EditSolutionHintBodyPopup;
    //   }
  }

  //return from answernote
  REdirecttoRightAnswerfromnote(data: any) {
    this.Screenname = data;
    this.ReturnAnswerfromnote();
  }

  ReturnAnswerfromnote() {
    //this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
    let Templist = {
      Answer_Choice_ID: null,
      Question_ID: this.selectedQuestionById.Question_ID,
      Question_Status_ID: this.selectedQuestionById.Question_Status_ID,
    };
    if (this.RightAnswer1 != null) {
      this.SelectedAnswer = this.RightAnswer1;
      this.AnswerIndicator = 'R';
    } else {
      this.SelectedAnswer = Templist;
    }
    let list = {
      QuestionById: this.SelectedAnswer,
      Answerflag1: this.AnswerIndicator,
    };

    this.ClickAnswerChoice(list);

    //  if(this.AnswerChoiceNotePopup1){
    //   this.AnswerChoiceNoteBody();
    // }if()

    if (this.Screenname == 'app-answer-choice-note') {
      this.AnswerChoiceNotePopup1 = !this.AnswerChoiceNotePopup1;
    } else if (this.Screenname == 'app-answer-choice-solution-hint') {
      this.SolutionHintPopup = !this.SolutionHintPopup;
    }
  }

  PreviewAnswer() {
    //this.getQuestionByID(this.selectedQuestionById[0].Question_ID);
    let Templist = {
      Answer_Choice_ID: null,
      Question_ID: this.service.QuestionByIDlist[0].Question_ID,
      Question_Status_ID: this.service.QuestionByIDlist[0].Question_Status_ID,
    };
    //  if(this.RightAnswer1!=null){
    //    this.SelectedAnswer=this.RightAnswer1;
    //    this.AnswerIndicator='R';
    //  }
    //  else{
    //    this.SelectedAnswer=Templist;
    //  }
    this.service
      .GetAnswerChoiceByQuestionID({
        QuestionID: this.service.QuestionByIDlist[0].Question_ID,
      })
      .subscribe(
        (i: any) => {
          this.AnswerChoice = i;
          this.AnswerChoiceByQuestionid = this.AnswerChoice.SubjectExistsInd;
          if (this.AnswerChoiceByQuestionid.length != 0) {
            if (this.AnswerChoiceByQuestionid[0].Answer_Choice_ID != null) {
              this.SelectedAnswer = this.AnswerChoiceByQuestionid[0];
              if (this.AnswerChoiceByQuestionid[0].Right_Answer_Ind == 'Y') {
                this.AnswerIndicator = 'R';
              } else {
                this.AnswerIndicator = 'W';
              }
            } else {
              this.SelectedAnswer = Templist;
            }
          } else {
            this.SelectedAnswer = Templist;
          }
          let list = {
            QuestionById: this.SelectedAnswer,
            Answerflag1: this.AnswerIndicator,
          };

          this.ClickAnswerChoice(list);

          this.Questionpreviewpopupflag = !this.Questionpreviewpopupflag;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
